import { render, staticRenderFns } from "./DicomView.vue?vue&type=template&id=748da407&scoped=true&"
import script from "./DicomView.vue?vue&type=script&lang=js&"
export * from "./DicomView.vue?vue&type=script&lang=js&"
import style0 from "./DicomView.vue?vue&type=style&index=0&id=748da407&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748da407",
  null
  
)

export default component.exports